module.exports = __webpack_public_path__ + "img/princess.c9ddd4b0.gif";